/* tslint:disable */
/* eslint-disable */
/**
 * Atlas API
 * Atlas API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CreditsChangeSummaryMeta,
    CreditsChangeSummaryMetaFromJSON,
    CreditsChangeSummaryMetaFromJSONTyped,
    CreditsChangeSummaryMetaToJSON,
    RequestDetail,
    RequestDetailFromJSON,
    RequestDetailFromJSONTyped,
    RequestDetailToJSON,
    ResponseBase,
    ResponseBaseFromJSON,
    ResponseBaseFromJSONTyped,
    ResponseBaseToJSON,
} from './';

/**
 * 
 * @export
 * @interface RequestDetailsListWithCreditsChangeSummaryResponse
 */
export interface RequestDetailsListWithCreditsChangeSummaryResponse {
    /**
     * Message related to response
     * @type {string}
     * @memberof RequestDetailsListWithCreditsChangeSummaryResponse
     */
    msg: string;
    /**
     * 
     * @type {Array<RequestDetail>}
     * @memberof RequestDetailsListWithCreditsChangeSummaryResponse
     */
    entries: Array<RequestDetail>;
    /**
     * 
     * @type {CreditsChangeSummaryMeta}
     * @memberof RequestDetailsListWithCreditsChangeSummaryResponse
     */
    meta: CreditsChangeSummaryMeta;
}

export function RequestDetailsListWithCreditsChangeSummaryResponseFromJSON(json: any): RequestDetailsListWithCreditsChangeSummaryResponse {
    return RequestDetailsListWithCreditsChangeSummaryResponseFromJSONTyped(json, false);
}

export function RequestDetailsListWithCreditsChangeSummaryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestDetailsListWithCreditsChangeSummaryResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'msg': json['msg'],
        'entries': ((json['entries'] as Array<any>).map(RequestDetailFromJSON)),
        'meta': CreditsChangeSummaryMetaFromJSON(json['meta']),
    };
}

export function RequestDetailsListWithCreditsChangeSummaryResponseToJSON(value?: RequestDetailsListWithCreditsChangeSummaryResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'msg': value.msg,
        'entries': ((value.entries as Array<any>).map(RequestDetailToJSON)),
        'meta': CreditsChangeSummaryMetaToJSON(value.meta),
    };
}


